import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'; 
import { Typography, Box, Container } from '@mui/material';
import { UseImage, Buttons, CustomLoadingOverlay, GenericContainer } from '../../components';
import { addTitleLegoCurrent, workflowActions } from '../../store/actions'; 
import { coreFunctions } from '../../utils'; 
import { useTranslation } from 'react-i18next';
import EncuestaImg from '../../assets/EncuestaP2.png';

export default function EndSurvey() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [loadView, setLoadView] = useState(false);
  const [nextWF, setNext] = useState(false);
  const [propsStage, setPropsStage] = useState({
    title: 'Encuesta',
    icon: 'IconoEncuestaP1',
    description: '',
    buttonText: 'Continuar',
  });

  const file = useSelector((state) => state.FileInfo);
  const continueWF = useSelector((state) => state.ContinueWorkflow);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoadView(file.loading);
    if (file.items != undefined) {
      let title = file.items.Stage.Properties.find((el) => el.Name === 'TitleP3');
      let icon = file.items.Stage.Properties.find((el) => el.Name === 'IconNameP3');
      let description = file.items.Stage.Properties.find((el) => el.Name === 'DescriptionP3');
      let buttonText = file.items.Stage.Properties.find((el) => el.Name === 'ButtonTextP3');

      dispatch(addTitleLegoCurrent(title?.Value));
      setPropsStage({
        title: title?.Value || "Encuesta",
        icon: icon?.Value || "IconoEncuestaP1",
        description: description?.Value || "",
        buttonText: buttonText?.Value || "Continuar",
      });
    }
  }, [file]);

  const handleFinish = async () => {
    if (!file.items) return;
    setLoadView(true);
    dispatch(workflowActions.ContinueWorkflowAction({ File_Id: file.items?.Id }));
    setNext(true)
    setLoadView(false);
  };

  useEffect(() => {
    setLoadView(continueWF.loading);
    if (continueWF.items != undefined && nextWF) {
      console.log('continueWF:StageName::', continueWF?.items?.Stage?.Name);

      let performLogout =
        continueWF.items.Stage.Properties.find((element) => element.Name == 'PerformLogout')
          ?.Value || '0';

      console.log('continueWF:PerformLogout::', performLogout);

      let currentStageName = file?.items?.Stage?.Name;
      let nextStage = continueWF.items.Stage;
      let stageName = nextStage.Name;
      let stageId = nextStage.Id;
      let stage = continueWF.items;
      let folioId = file.items.Id;

      const shouldLogout =
        performLogout == '1' && currentStageName != 'Información de la Solicitud';

      if (shouldLogout) {
        navigate('/main/WelcomePortal');
      } else {
        let nextComponent = coreFunctions.GetLegoNext(stageName);
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: { stageName, stageId, stage, folioId },
        });
      }
      let title = continueWF.items.Stage.Description;
      dispatch(addTitleLegoCurrent(title));
      setLoadView(false);
    }
  }, [continueWF]);

  const content = (
    <Container
      maxWidth="sm"
      sx={{
        height: 'calc(100vh - 11rem)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {loadView && (
        <CustomLoadingOverlay active={loadView} text={t('general_loading_advancedsign')} />
      )}
      <Box display="flex" justifyContent="center" width="100%">
        <UseImage style={{ maxWidth: 300 }} src={EncuestaImg} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', my: 3, alignItems: 'center' }}>
        <Typography>{propsStage.description}</Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, alignItems: 'center' }}>
        <Buttons ConfirmButtonText={propsStage.buttonText} onClickConfirm={() => handleFinish()} />
      </Box>
    </Container>
  );

  return <GenericContainer>{content}</GenericContainer>
}
